export type MetricFormat = 'raw' | 'number' | 'currency' | 'percent'

const DASH = '—'

const compactNumber = new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 })

export function formatNumber(value: unknown) {
  return value == null || value === '' ? DASH : Number(value).toLocaleString()
}

export function formatCredits(value: number) {
  return compactNumber.format(value)
}

export function formatCurrency(value: unknown) {
  return value == null || value === '' ? DASH : `$${Number(value).toFixed(2)}`
}

export function formatPercent(value: unknown) {
  return value == null || value === '' ? DASH : `${Number(value).toFixed(2)}%`
}

export function formatValue(value: unknown, format: MetricFormat) {
  switch (format) {
    case 'number':
      return formatNumber(value)
    case 'currency':
      return formatCurrency(value)
    case 'percent':
      return formatPercent(value)
    default:
      return value == null || value === '' ? DASH : String(value)
  }
}

export function formatDate(iso?: string | null) {
  if (!iso) return DASH
  return new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}

export function formatDateTime(iso?: string | null) {
  if (!iso) return ''
  const date = new Date(iso)
  const day = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  return `${day} ${date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}`
}

export function titleCase(value?: string | null) {
  if (!value) return DASH
  return value.charAt(0) + value.slice(1).toLowerCase().replace(/_/g, ' ')
}

export function relativeTime(iso: string) {
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60000)
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.round(hours / 24)
  if (days < 7) return `${days}d ago`
  return new Date(iso).toLocaleDateString()
}
